export enum ScrollState {
    Idle = 'idle',
    Requesting = 'requesting',
    Waiting = 'waiting',
    Shown = 'shown',
    Ended = 'end',
    Failed = 'failed',
}
